import { PRO_REGISTRATION_VARIANT } from '../../views/auth/RegisterView/helpers';
import {
  FREEMIUM_EVENT_SIGNUP_FLOW_VARIANTS,
  FREEMIUM_EVENT_CREATE_WALDOFIED_STEP_VARIANTS,
  FREEMIUM_EVENT_CREATE_SKU_UPSELL_STEP_VARIANTS,
} from '../../apps/shutterbug/views/SignupAlbumCreate/helpers';

/**
 * Experiment keys.
 *
 * @enum EXPERIMENT_KEY
 * @type {{MEMBERSHIPS_PURCHASING_OPTIONS: string}}
 */
export const EXPERIMENT_KEY = {
  MEMBERSHIPS_PURCHASING_OPTIONS: 'MEMBERSHIPS_PURCHASING_OPTIONS',
  REGISTRATION_CC_CAPTURE: 'REGISTRATION_CC_CAPTURE',
  FREEMIUM_EVENT_SIGNUP_FLOW: 'FREEMIUM_EVENT_SIGNUP_FLOW',
  FREEMIUM_EVENT_CREATE_WALDOFIED_STEP: 'FREEMIUM_EVENT_CREATE_WALDOFIED_STEP',
  FREEMIUM_EVENT_CREATE_SKU_UPSELL_STEP:
    'FREEMIUM_EVENT_CREATE_SKU_UPSELL_STEP',
};

/**
 * Experiment metadata and variations.
 *
 * @type {{}}
 */
const experiments = {
  [EXPERIMENT_KEY.REGISTRATION_CC_CAPTURE]: {
    id: 'ujWKgOWKShW3mDMUiVAHNA',
    name: 'Registration CC Capture',
    description: 'PRO Registration Free Trial - Credit Card vs No Credit Card',
    variants: [
      PRO_REGISTRATION_VARIANT.VARIANT_A, // No credit card
      PRO_REGISTRATION_VARIANT.VARIANT_B, // Credit card
    ],
  },
  [EXPERIMENT_KEY.FREEMIUM_EVENT_SIGNUP_FLOW]: {
    id: 'PtRl_4-_Sa2c0mOkVOBuEQ',
    name: 'Freemium Event Signup Flows',
    description:
      'Alters the order of steps the user goes through for creating a freemium event.',
    variants: [
      FREEMIUM_EVENT_SIGNUP_FLOW_VARIANTS.VARIANT_A, // Signup at the end
      FREEMIUM_EVENT_SIGNUP_FLOW_VARIANTS.VARIANT_B, // Signup at the start
    ],
  },
  [EXPERIMENT_KEY.FREEMIUM_EVENT_CREATE_WALDOFIED_STEP]: {
    id: 'PDVc6pXuSyiRWWK8MWYHVw',
    name: 'Gold Upsell Step Design Test',
    description: 'Alters the designs of the Gold upsell step during signup.',
    variants: [
      FREEMIUM_EVENT_CREATE_WALDOFIED_STEP_VARIANTS.VARIANT_A, // Illustration
      FREEMIUM_EVENT_CREATE_WALDOFIED_STEP_VARIANTS.VARIANT_B, // Comparison chart
    ],
  },
  [EXPERIMENT_KEY.FREEMIUM_EVENT_CREATE_SKU_UPSELL_STEP]: {
    id: 'Ok3OFv29TVuSHQDQB09cyA',
    name: 'SKUs Upsell Step Title And Style Test',
    description:
      'Changes the title and illustration shape for the upsell SKU selection step.',
    variants: [
      FREEMIUM_EVENT_CREATE_SKU_UPSELL_STEP_VARIANTS.VARIANT_A, // Rectangle shape + Positive Message
      FREEMIUM_EVENT_CREATE_SKU_UPSELL_STEP_VARIANTS.VARIANT_B, // Rectangle shape + FOMO
      FREEMIUM_EVENT_CREATE_SKU_UPSELL_STEP_VARIANTS.VARIANT_C, // Square shape +  FOMO
      FREEMIUM_EVENT_CREATE_SKU_UPSELL_STEP_VARIANTS.VARIANT_D, // Square shape +  Positive Message
    ],
  },
};

export default experiments;
